var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"iframe",attrs:{"src":'https://www.v-can.cn/test?lang=' + _vm.lang,"border":"0px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }